import React from "react";
import "./TestiCards.css";

export default function TestiCards({ description, name, post, pic }) {
  return (
    <div className="testi-cards">
      <div className="testimonial">
        <p>{description}</p>
      </div>
      <div className="pro-card">
        <div className="pro-card-img">
          <img src={pic} alt="not found" />
        </div>
        <h5>{name}</h5>
        <span>{post}</span>
      </div>
    </div>
  );
}
